import ServiceFactory from '../../service_factory';
import {IElasticEventData} from '../../../../../common/interfaces/structured-logging-service-interface';
import {Check} from '@sparkware/app-utils';

export class LogEventDataBuilder {
    constructor(private readonly services: ServiceFactory, private readonly _eventData: IElasticEventData) {
        this._eventData = _eventData || {};
        //validate data from the commonly reported fields
        this.addCategory(_eventData.CGPEventCategory);
        this.addAction(_eventData.CGPEventAction);
        this.addLabel(_eventData.CGPEventLabel);
        this.addValue(_eventData.CGPEventValue);
        this.addEventName(_eventData.eventName);
        this._eventData.event = 'CGP_GENERIC_EVENT';
        if (this.services.integrationService().isMiniCip()) {
            this._eventData.isMiniCIP = true;
        }

        if (this.services.integrationService().isMiniCis()) {
            this._eventData.isMiniCIS = true;
        }
    }

    build(): IElasticEventData {
        return this._eventData;
    }

    addCategory(category:string): void {
        if(!Check.isNullOrUndefined(category)) {
            this._eventData.CGPEventCategory = this._prepareString(category);
        }
    }
    addAction(action:string): void {
        if(!Check.isNullOrUndefined(action)) {
            this._eventData.CGPEventAction = this._prepareString(action);
        }
    }
    addLabel(label:string): void {
        if(!Check.isNullOrUndefined(label)) {
            this._eventData.CGPEventLabel = this._prepareString(label);
        }
    }
    addValue(value:string): void {
        if(!Check.isNullOrUndefined(value)) {
            this._eventData.CGPEventValue = this._prepareString(value);
            const valueAsNumber = Number(value);
            if (Check.isNumber(valueAsNumber)) {
                this._eventData.CGPEventValueAsNumber = valueAsNumber;
            }
        }
    }
    addEventName(eventName:string): void {
        if(!Check.isNullOrUndefined(eventName)) {
            this._eventData.eventName = this._prepareString(eventName);
        }
    }
    addCustomData(customData: object): void {
        if(!Check.isNullOrUndefined(customData)) {
            this._eventData.customData = {
                ...this._eventData.customData,
                ...customData
            };
        }
    }
    _prepareString(data:string):string{
        if((typeof data) === "string"){
            return data;
        }
        return JSON.stringify(data);
    }
}
